import { getAuthToken, getUser } from "./GlobalApi";
const url = process.env.REACT_APP_API_URL;

const getLODashboard = async () => {
  const user = await getUser();
  const suffix = "dashboard/info/";
  return await fetch(`${url}${suffix}${user.id}`, {
    method: "GET",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${await getAuthToken()}`
    }
  });
};

const getDeals = async () => {
  const user = await getUser();
  const suffix = "deals";
  return await fetch(`${url}${suffix}${user.id}`, {
    method: "GET",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${await getAuthToken()}`
    },
  });
};

const getDeal = async (id) => {
  const suffix = "deal";
  return await fetch(`${url}${suffix}${id}`, {
    method: "GET",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${await getAuthToken()}`
    }
  });
};

const getBorrowers = async () => {
  const user = await getUser();
  const suffix = "borrowers";
  return await fetch(`${url}${suffix}${user.id}`, {
    method: "GET",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${await getAuthToken()}`
    }
  });
};

const getContacts = async () => {
  const user = await getUser();
  const suffix = "contacts";
  return await fetch(`${url}${suffix}${user.id}`, {
    method: "GET",
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${await getAuthToken()}`
    }
  });
};

export {
  getLODashboard,
  getDeals,
  getDeal,
  getBorrowers,
  getContacts
};